import React, { useEffect, useState } from 'react'
import { Col, Divider, Row, Input, Icon } from 'antd'
import VariablesCollapse from '@src/modules/molecules/variables-collapse';
import type { IAttributes, IVariable } from '@src/interfaces'
import { useSelector } from 'react-redux';
import { fetchVariables, show } from '@src/slices/configuration.slice';
import styles from './styles.module.scss'

interface IVariables {
	attributes: IAttributes[] | null,
	label?: string | undefined,
	name: string
	id: number
}

const ContainerVariables = ({ setTextSearch, textSearch }: { textSearch: string, setTextSearch: any }) => {
	const variables = useSelector(fetchVariables)
	const [searchVariables, setSearchVariables] = useState<IVariables[] | null>(null)

	const showVariables = useSelector(show)

	const handleSearch = (e: any) => {
		setTextSearch(e?.target?.value)
	}

	useEffect(() => {
		const array: IVariables[] | null = []
		if (textSearch !== "") {
			variables?.forEach((variable: IVariable, i: number) => {
				if (variable?.name.toLowerCase().includes(textSearch.toLowerCase())) {
					array.push(variable)
				} else {
					variable?.attributes?.forEach((att: IAttributes) => {
						if ((att?.name.toLowerCase().includes(textSearch.toLowerCase()))) {
							const indexCurrent = array.findIndex((v: IVariable) => v.id === i)
							if (indexCurrent > -1) {
								array[indexCurrent].attributes?.push(att)
							} else {
								array.push({
									...variable,
									attributes: [att]
								})
							}

						}
					})
				}
			})
			setSearchVariables(array)
		} else {
			setTextSearch("")
			setSearchVariables(null)
		}
	}, [textSearch])
	

	const [scroll, setScroll] = useState(false);

	useEffect(() => {
		window.addEventListener("scroll", () => {
			setScroll(window.scrollY > 135)
		})

		return () => {
			window.removeEventListener("scroll", () => {
				setScroll(window.scrollY > 135)
			})
			setTextSearch("")
		}
	}, [])

	return (
		<div className={showVariables ? scroll ? styles.colItemFixed : styles.colItemTwoBorder : styles.colItemWitchScroll}>
			<Row gutter={16}>
				<Col span={24}>
					<p className={styles.title}>Insertar variables</p>
					<p className={styles.subTitle}>Usa las variables para generar documentos con los datos de los colaboradores y la organización.</p>
				</Col>
				<Col span={24}>
					<Input
						name='search'
						value={textSearch}
						placeholder="Buscar variables"
						onChange={handleSearch}
						className={styles.searchInput}
						suffix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
					/>
				</Col>
				<Divider className={styles.divider} />
				<Col span={24}>
					<VariablesCollapse search={searchVariables} />
				</Col>
			</Row>
		</div>
	)
}

export default ContainerVariables